// extracted by mini-css-extract-plugin
export default {"card":"CY-z","carouselContainer":"DY-z","carouselContent":"EY-z"};